window.SMTX.solutionsIndex = (function () {

  if ($('.link-index').length > 0 && $('.solutions-index-page').length > 0 ) {
    log('Solutions page');
  }else{
    return false;
  }

  var $_filterContainer = $(".solutions-index-page [data-filters]");
  
  $(document).ready(function () {
    if (window.location.hash) {
      
      // change from 'smooth' to 'auto' to avoid scroll animation issue
      $('html').css('scroll-behavior', 'auto');
      
      var hash = window.location.hash;
      var deeplink = hash.substring(1);

      var $deeplink = $(`[data-deeplink=${deeplink}]`);
      if ($deeplink.length) {
        var $accordionContent = $deeplink.closest('.accordion-content');
        var $accordion = $accordionContent.closest('.accordion');

        // prevent accordion from animating on load
        $accordionContent.css('display', 'block');
        $accordion.foundation('down', $accordionContent);

        // extra offset for mobile
        var isMobile = $('.burger-button').css('display') !== 'none';
        var extraOffset = isMobile ? 20 : 50;

        var offset = $('.top-menu').outerHeight() + extraOffset;
        var scrollTopElem = $accordion.closest('.collapsible-link-index');

        $('html, body').animate(
          {
            scrollTop: scrollTopElem.offset().top - offset,
          },
          450,
          function () {
            // change back to 'smooth'
            $('html').css('scroll-behavior', 'smooth');
          }
        );
      }
    }
  })
  

  // loop link-index modules and create filters
  //<a href="#link" class="button secondary small hollow">Title</a>
  $('.link-index').each(function () {
    var $me = $(this);
    var n = $me.attr('data-name');

    var $svg = $me.find('.icon').clone();
    
    if (n !== '') {
      var $filter_btn = $(
        `<a href="#${toUrlTitle(n)}" data-filter-id="${toUrlTitle(n)}" class="button secondary small hollow ${
          $svg.length && 'icon-wrapper'
        }" >${n}</a>`
      );
      
      if ($svg.length) {
        $filter_btn.prepend($svg);
      }
      
      $me.attr('data-cat-id', toUrlTitle(n));

      $_filterContainer.append($filter_btn);
    }
  });

  $('.filters').removeClass('hide');

  function toUrlTitle(str){
    //return str.replace(" ", "-").toLowerCase();
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
    
    str = str.replace('æ', 'ae');
    
    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôøùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiiooooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes


    return str;
  }


  function string_to_slug (str) {

}
  $('[data-filters] a').on('click', function () {
    $(this).blur();
  });

  $(window).on('hashchange', function () {
    setActiveCategory();
  });
  // onload: check hash

  // onclick (or on url change?): checkhash

  // checkhash ()
  // - what is hash
  // - hide all, show the one
  // - set active button

  function setActiveCategory(){
    var hashValue = getHashValue();
   //log(hashValue);
    var subCat = false;
    if(hashValue.indexOf('|') > 0 ){
      var hashArr = hashValue.split('|');
      hashValue = hashArr[0];
      subCat = (!isNaN(parseInt(hashArr[1]))) ? parseInt(hashArr[1]) : false;
    }
    // log('final hash: ' + hashValue);
    // log('subcat: ' + subCat);
    var hasIndex = false;
    
    $('.link-index').each(function () {
      var $me = $(this);
      //log($me.attr('data-cat-id'));
        if($me.attr('data-cat-id') === hashValue ){
          hasIndex = true;

          // filter btn
          $('.filters a').addClass('hollow');
          $('.filters a[data-filter-id="' + hashValue + '"]').removeClass('hollow');
          
          // cat
          $('.link-index').addClass('hide');
          $me.removeClass('hide');  
        }
    });

    if(!hasIndex){
      $('.link-index').removeClass('hide');
      $('.filters a').addClass('hollow');
      $('.filters a[data-all]').removeClass('hollow');
      $("html, body").animate({ scrollTop: 0 }, 250);
    }else if(subCat > 0){
      
      var t = $('[data-cat-id="' + hashValue + '"] [data-cat-index="' + subCat + '"]');
      if(t && t.offset() ){
        $("html, body").animate({ scrollTop: t.offset().top - 100 }, 250);
      }
    }else if( window.scrollY < 10 ){
      $("html, body").animate({ scrollTop: 85 }, 250);
    }

  }


  // init

  $(window).trigger('hashchange');

  function getHashValue() {
    // Get the current URL hash value (including the '#' symbol)
    var currentHash = window.location.hash;
    // Remove the '#' symbol and return the hash value
    return currentHash.substring(1);
  }
  

  return {

  };

})();
